var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('h1',{staticClass:"text-3xl font-bold mb-6 text-gray-800"},[_vm._v("Dashboard")]),_c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6"},[_c('UserGroupManagement'),(_vm.isSuperAdmin)?_c('AdminActions'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }